import { render, staticRenderFns } from "./CoreImageLightbox.vue?vue&type=template&id=9592f388&"
import script from "./CoreImageLightbox.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreImageLightbox.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9592f388')) {
      api.createRecord('9592f388', component.options)
    } else {
      api.reload('9592f388', component.options)
    }
    module.hot.accept("./CoreImageLightbox.vue?vue&type=template&id=9592f388&", function () {
      api.rerender('9592f388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreImageLightbox/CoreImageLightbox.vue"
export default component.exports